const ProgressCard = ({index,title,description}) => {
 
  return (
    <div className={`Progress-card ${index%2===0?"highlight":""}`}>
        <h1>→{index}</h1>
        <h5>{title}</h5>
        <p>{description}</p>
    </div>
  )
}

export default ProgressCard